var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"button special",attrs:{"disabled":_vm.lockButton,"type":"submit","value":"Subscribe"},on:{"click":function($event){$event.preventDefault();return _vm.subscribe.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }